






















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import { JianchaHengjiList, ZhenciList } from "@/request/sjzx";
import { InstitutionList } from "@/request/zhuanbingshujuku";
import { GetUserInfo, ZuzhijiagouList } from "@/request/yonghuquanxian";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/nav-left.vue";
import JiluRender from "../../components/jilu-render.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
    JiluRender,
  },
})
export default class Jchj extends Vue {
  // 当前用户信息
  private user: any = {};
  private filters: any = {
    institution_id: "",
    zhenci: "",
    search: "",
    currentPage: 1,
    totalPage: 0,
    totalCount: 0,
    pageSize: 10,
    cSortField: "创建时间",
    cSortValue: "0",
  };
  private ifLoading: boolean = false;
  // 搜索条件
  private institutions: any[] = [];
  private zhencis: any[] = [];
  // 列表
  private infos: any[] = [];
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }

  @Watch("center", { immediate: true, deep: true })
  private centerChange(e) {
    const localFilters = localStorage.getItem("jchjFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        institution_id: "",
        zhenci: "",
        search: "",
        currentPage: 1,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
        cSortField: "创建时间",
        cSortValue: "0",
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    if (e.project_id) {
      this.getCurrentUserInfo();
      this.fetchInfos().then(() => {
        this.getInstitutions();
        this.getZhencis();
      });
    }
  }
  private setFilters() {
    localStorage.setItem("jchjFilters", JSON.stringify(this.filters));
  }
  /**
   * @description 获取当前用户信息
   */
  private getCurrentUserInfo() {
    if (!this.center.project_id) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    GetUserInfo(this, params).then((data: any) => {
      this.$set(this, "user", data);
    });
  }
  /**
   * @description 搜索可选的机构
   */
  private getInstitutions() {
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      this.institutions = _.uniqBy(data, "institution_id");
    });
  }

  /**
   * @description 选择机构改变
   */
  private institutionChange() {
    this.getZhencis();
    this.search();
  }
  /**
   * @description 搜索可选的诊次
   */
  private getZhencis() {
    const params: any = {
      project_id: this.center.project_id,
    };
    if (this.filters["institution_id"]) {
      params["institution_id"] = this.filters["institution_id"];
    }
    ZhenciList(this, params).then((data: any) => {
      this.zhencis = data;
    });
  }
  /**
   * @description 诊次改变
   */
  private zhenciChange() {
    this.search();
  }
  /**
   * @description 获取病人列表
   */
  private fetchInfos() {
    return new Promise((resolve, reject) => {
      this.ifLoading = true;
      const params: any = {};
      // 处理基本搜索条件
      params["institution_id"] = this.filters.institution_id;
      params["zhenci"] = this.filters.zhenci;
      params["project_id"] = this.center.project_id;
      params["order_field"] = this.filters.cSortField;
      params["order_value"] = this.filters.cSortValue;
      params["current_page"] = this.filters.currentPage;
      params["page_count"] = this.filters.pageSize;
      params["search"] = this.filters.search;

      JianchaHengjiList(this, params)
        .then((data: any) => {
          data.jianchas.forEach((item: any) => {
            item.ifShowDetail = true;
          });
          this.infos = data.jianchas;
          this.filters.totalPage = data.total_page;
          this.filters.totalCount = data.total_count;
          resolve();
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          this.setFilters();
          this.ifLoading = false;
        });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.currentPage = 1;
    this.fetchInfos();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.currentPage = val;
    this.fetchInfos();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filters.cSortField = ev["prop"];
    this.filters.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchInfos();
  }
}
